var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"message-image message-component",style:(_vm.imageStyle)},[_c('el-image',{staticClass:"img-box",attrs:{"src":_vm.data.url,"preview-src-list":[_vm.data.url],"fit":'contain'},on:{"load":_vm.loadImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }